// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-wrapper[data-v-58fca33d],.video-wrapper .mobile_video[data-v-58fca33d]{display:block;width:100%;height:100%}.video-wrapper .mobile_video[data-v-58fca33d]{-o-object-fit:cover;object-fit:cover}@media (min-width:1024px){.video-wrapper .mobile_video[data-v-58fca33d]{display:none}}.video-wrapper .hero_video[data-v-58fca33d]{display:none}@media (min-width:1024px){.video-wrapper .hero_video[data-v-58fca33d]{display:block}}", ""]);
// Exports
module.exports = exports;
